import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params, RouterOutlet } from '@angular/router';
import { EventService } from '@services/event.service';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vevent',
  templateUrl: './vevent.component.html',
  styleUrls: ['./vevent.component.sass'],
   animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VeventComponent implements OnInit {
  pathToMedia: any = {};
  review_renter=false;
  rate = 0;
  document_list: any = [];
  application = "event";
  component = '';
  params: any = [];
  id = "";
  hours:any=[];
  response: any = [];
  image_paths: any = [];
  g_url = '';
  y_url = '';
  o_url = '';
  rows = 1;
  isLogin = false;
  is_owner = false;
  report_param: any = [];
  doc_videos: any = [];
  doc_photos: any = [];
  doc_document: any = [];
  page_load = true;
  share_btn_list: any = ['facebook', 'twitter', 'linkedin', 'reddit', 'whatsapp', 'telegram', 'email'];
  invitation_requested: any = [];
  invitation_requested_key: any = [];
  invitation_rejected: any = [];
  invitation_rejected_key: any = [];
  invitation_received: any = [];
  invitation_received_key: any = [];
  requested = false;
  rejected = false;
  received = false;
  customOptions = {
    loop: true,
    items: 1,
    autoplay: true,
    center: true,
    dots: false,
    nav: true,
    autoHeight: true,
    autoWidth: true,
    smartSpeed: 1000,
    autoplayTimeout: 5000,
    navText: [
      '<i class="fa fa-angle-left" aria-hidden="true"></i>',
      '<i class="fa fa-angle-right" aria-hidden="true"></i>'
    ]
  }
  carousel_img_options: any = { mediaType: 'photo', id: 'uid', name: 'name', size: 'xl' };
  user_id = '';
  latitude="";
  address="";
  map_url='https://www.google.com/maps/embed/v1/place?q=';
  sidetabs={"recent":"Recent","viewed":"Views","rated":"Popular","liked":"Liked","favorites":"Favorite"};
  constructor( private _event: EventService,private router: Router, private datePipe: DatePipe, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.rows = this._global.ROWS;

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
      this.user_id = this._global.getSessionVal('id')
    }

    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.response = this._global.getVal(data, 'response', '');
            this.latitude=this._global.getVal(this.response,'latlong.lat','');
            this.map_url= this.map_url + this._global.getVal(this.response,'location.streetAddress','noaddress')+'&zoom=17&key='+this._global.GOOGLE_API;
            this.g_url = "https://www.google.com/calendar/render?action=TEMPLATE&text=" + this.response.title + "&dates=" + this.datePipe.transform(this.response.startTime, 'yMMddTHHmmss', this.response.timeZone) + "/" + this.datePipe.transform(this.response.endTime, 'yMMddTHHmmss', this.response.timeZone) + "&location=" + this._global.getVal(this.response, 'location.city', '');
            this.y_url = "https://calendar.yahoo.com/?v=60&title=" + this.response.title + "&st=" + this.datePipe.transform(this.response.startTime, 'yMMddTHHmmss', this.response.timeZone) + "&et=" + this.datePipe.transform(this.response.endTime, 'yMMddTHHmmss', this.response.timeZone) + "&in_loc=" + this._global.getVal(this.response, 'location.city', '');
      
            this.report_param = {
              id: this.response.id,
              name: this.response.title
            };
            let p = {
              id: this.response.id,
              application: this.application,
              component: this.component
            }
            this._event.invitation(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let res = this._global.getVal(data, 'response', '');
                  this.invitation_requested.push(this._global.getVal(res, 'requested', {}));
                  this.invitation_requested_key = Object.keys(this.invitation_requested[0]);
                  this.invitation_received.push(this._global.getVal(res, 'received', {}));
                  this.invitation_received_key = Object.keys(this.invitation_received[0]);
                  this.invitation_rejected.push(this._global.getVal(res, 'rejected', {}));
                  this.invitation_rejected_key = Object.keys(this.invitation_rejected[0]);
                  let THIS = this;
                  let req = this.invitation_requested_key.find(x => x == THIS.user_id);
                  let rec = this.invitation_received_key.find(x => x == THIS.user_id);
                  let rej = this.invitation_rejected_key.find(x => x == THIS.user_id);
                  if (req) {
                    this.requested = true;
                  }
                  if (rec) {
                    this.received = true;
                  }
                  if (rej) {
                    this.rejected = true;
                  }
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            this.rate = this._global.getVal(this.response, 'rating', '');
            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            let img = {
              uid: this.response.id,
              name: this.response.title,
              mediaType: this.application
            };
            this.image_paths.push(img);
            Object.values(this.pathToMedia).forEach((key, value) => {
              this.image_paths.push(key);
            });
            this.hours= this._global.getVal(this.response, 'location.hours', []);
            this.response['application'] = this.application;
            this.response['website_url'] = this._global.SITE_URL + '/view/event?a=event&c=b&id=' + this.response.id;
            this._global.addMetaInfo(this.response, 'view','title');
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));

          }else{
            this.router.navigate(['']);
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    
  }
  ngOnInit() {

  }
  attend(type, status) {

    let pa = {
      component: this.component,
      application: this.application,
      mediaId: this.id,
      id: this.response.id,
      status: status
    };
    this._event.respond(pa, type).subscribe(
      data => {

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  returnZero() {
    return 0
  }

  edit() {
    this.router.navigate(['/edit/' + this.application], { queryParams: { 'id': this.id } });
  }
  pageScrollDown(){
   this.review_renter=true;
  }

}
